import { OnInit } from '@angular/core';
var EmailVerificationComponent = /** @class */ (function () {
    function EmailVerificationComponent() {
    }
    EmailVerificationComponent.prototype.ngOnInit = function () {
    };
    return EmailVerificationComponent;
}());
export { EmailVerificationComponent };
